import { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { saveAds } from '@bingads-webui-campaign-react/xandr-video-campaign-shared-components';
import { useAdsRepository } from '../../common/use-ads-repository';
import { getDefaultCampaign, getDefaultAdGroup } from './constants';

export const useDisplayAdsRepository = (defaultCampaign, defaultAdGroup) => {
  const i18n = useContext(I18nContext);

  const serverContext = useContext(ServerContext);

  const { load, save } = useAdsRepository({
    saveAds,
    defaultCampaign: defaultCampaign || getDefaultCampaign(i18n, serverContext),
    defaultAdGroup: defaultAdGroup || getDefaultAdGroup(i18n, serverContext),
  });

  return {
    load,
    save,
  };
};
